import WorkoutExercisesHeader from './WorkoutExercisesHeader';

export default WorkoutExercisesHeader;
